var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[(_vm.isLargeScreen)?_c('SideBarLists',{attrs:{"providerId":_vm.providerId,"productList":_vm.productList}}):_vm._e(),_c('ProductItems',{attrs:{"providerId":_vm.providerId,"productListKey":_vm.productListKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }